import { useCallback, useEffect, useRef } from "react"

const useStickyHeader = (setJumpMenu, setIsPreheader) => {
  const headerRef = useRef(null)
  const preheaderRef = useRef(null)
  const discountRef = useRef(null)

  const updateRefs = () => {
    headerRef.current = document.querySelector(".header")
    preheaderRef.current = document.querySelector(".preheader")
    discountRef.current = document.querySelector(".discount-preheader")
  }

  const checkPreheader = useCallback(() => {
    if (typeof setIsPreheader === "function") {
      setIsPreheader(window.innerWidth >= 992)
    }
  }, [setIsPreheader])

  const handleScroll = useCallback(() => {
    const offset = window.scrollY
    const header = headerRef.current
    const preheader = preheaderRef.current
    const discount = discountRef.current

    const jumpMenuCount = document.querySelectorAll(".responsive-menu-btn").length
    if (typeof setJumpMenu === "function") {
      setJumpMenu(jumpMenuCount)
    }

    if (header) {
      const headerHeight = header.clientHeight
      const preheaderHeight = preheader?.clientHeight || 0
      const discountHeight = discount?.clientHeight || 0

      const shouldStick = offset >= preheaderHeight + discountHeight

      document.body.style.paddingTop = shouldStick ? `${headerHeight}px` : "0"
      document.body.classList.toggle("sticky-menu", shouldStick)
    }
  }, [setJumpMenu])

  useEffect(() => {
    const onScrollOrResize = () => {
      window.requestAnimationFrame(() => {
        updateRefs()
        handleScroll()
        checkPreheader()
      })
    }

    window.addEventListener("scroll", onScrollOrResize)
    window.addEventListener("resize", onScrollOrResize)

    // Run once on mount
    onScrollOrResize()

    return () => {
      window.removeEventListener("scroll", onScrollOrResize)
      window.removeEventListener("resize", onScrollOrResize)
    }
  }, [handleScroll, checkPreheader])
}
export default useStickyHeader
